import cx from 'classnames';
import CopyButton from '~/components/CopyButton';
import React, { FC } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface CopyableUUID {
  id?: string;
  className?: string;
}

const CopyableUUID: FC<CopyableUUID> = (props) => {
  const { id, className } = props;

  const classes = useStyles();

  return (
    <div className={cx(classes.container, className)}>
      <div className={classes.uuid}>{id}</div>
      <CopyButton value={id ?? ''} classes={classes} />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  uuid: {
    color: theme.palette.grey[500],
  },
  container: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'baseline',
  },
  // For copy button
  button: {
    padding: 0,
    color: theme.palette.grey[500],
    marginLeft: 10,
  },
  icon: {
    fontSize: '1rem',
  },
}));

export default CopyableUUID;
